// extracted by mini-css-extract-plugin
export default {"root":"river-sidebar-toggle_root__eEfQj","collapsed":"river-sidebar-toggle_collapsed__4CLru","mobile":"river-sidebar-toggle_mobile__WAYhw"};